var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 65",
    width: 64,
    height: 65,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "glob-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: none;stroke: #000000;stroke-width: 3.045 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M31.85 3.01C15.45 3.09 2.23 16.45 2.32 32.85C2.4 49.24 15.76 62.46 32.15 62.38C48.55 62.29 61.77 48.94 61.68 32.54C61.6 16.27 48.43 3.09 32.15 3.01L31.85 3.01L31.85 3.01ZM9.01 51.45C22.77 41.64 41.23 41.64 54.99 51.45M30.05 2.98C12.04 20.74 12.04 44.58 30.05 62.34M34.47 3.26C52.35 20.9 52.35 44.58 34.47 62.21M32 3.01L32 62.38M61.68 32.69L2.31 32.69M9.01 14.83C22.77 24.65 41.23 24.65 54.99 14.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlob);
export default __webpack_public_path__ + "static/media/glob.f7511979026a820abf3d9b9fe3ab6906.svg";
export { ForwardRef as ReactComponent };